import React from 'react';
import { ClipboardList, MessageCircle, MapPin, ArrowRight } from 'lucide-react';
import { supportOptions } from '../mock';
import useReveal from '../hooks/useReveal';

const iconMap = { ClipboardList, MessageCircle, MapPin };

const Support = () => {
  useReveal();
  return (
    <section id="service" className="py-16 lg:py-24 paper-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14 reveal">
          <div className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#F58220] mb-4">
            Happy Home Maker’s
          </div>
          <h2 className="h-display uppercase text-[40px] md:text-[64px] text-[#1a1410]">
            Need <span className="text-[#F58220]">Service Support</span>?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {supportOptions.map((s, i) => {
            const Icon = iconMap[s.icon];
            const isLink = !!s.link;
            const Tag = isLink ? 'a' : 'button';
            const props = isLink
              ? { href: s.link, target: '_blank', rel: 'noreferrer' }
              : {
                  type: 'button',
                  onClick: () =>
                    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }),
                };
            return (
              <Tag
                key={s.id}
                {...props}
                className="reveal group bg-white border border-[#E9D6C1] rounded-2xl p-8 card-lift text-left"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#F58220] flex items-center justify-center mb-6 group-hover:rotate-6 transition-transform duration-500">
                  <Icon className="w-6 h-6 text-white" strokeWidth={1.7} />
                </div>
                <div className="h-display uppercase text-[22px] text-[#1a1410] mb-2">{s.title}</div>
                <p className="text-[14px] leading-[1.7] text-[#4D4D4D]">{s.description}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] font-bold text-[#1a1410] border-b-2 border-[#F58220] pb-1 group-hover:text-[#F58220] transition-colors duration-400">
                  {s.cta}
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-400" />
                </div>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Support;
